import React from 'react';

import { assertExhaustiveSwitch } from '@paragon/utilities';

import { useAppSelector } from '../../../../../hooks';
import { AtticShapeDetails } from './AtticShapeDetails';
import { CommonShapeDetails } from './CommonShapeDetails';
import { FeaturePatternTrussShapeDetails } from './FeaturePatternTrussShapeDetails';
import FreeformProfileShapeDetails from './FreeformProfileShapeDetails';
import { GableShapeDetails } from './GableShapeDetails';
import { JackShapeDetails } from './JackShapeDetails';
import { PiggybackShapeDetails } from './PiggybackShapeDetails';
import { ScissorsShapeDetails } from './ScissorsShapeDetails';
import { ValleyShapeDetails } from './ValleyShapeDetails';

export function ShapeDetails() {
  const insertingObjectInfo = useAppSelector((state) => state.application.insertingObjectInfo);

  if (insertingObjectInfo?.type !== 'componentDesign') throw new Error('Expected to be inserting a component');

  const { definitionType, shape, shapeDetails } = insertingObjectInfo;
  if (definitionType === 'FeaturePattern') return <FeaturePatternTrussShapeDetails forInsertionComponent />;

  if (shapeDetails == null) {
    // When a profile truss is converted to settings it will always be treated as a FreeformProfile. In this case we
    //   won't have shape details, but we still need the shape to be editable.
    if (shape === 'FreeformProfile') return <FreeformProfileShapeDetails />;

    // That's a special case though. All other shapes are only encountered here during initial component insertion so
    //    we should always have shape details for them. Feature pattern trusses will never be encountered here.
    throw new Error(`Unable to edit shape details for shape '${shape}'`);
  }

  switch (shapeDetails?.type) {
    case 'Attic':
      return <AtticShapeDetails shapeDetails={shapeDetails} />;
    case 'Common':
      return <CommonShapeDetails shapeDetails={shapeDetails} />;
    case 'FreeformProfile':
      return <FreeformProfileShapeDetails />;
    case 'Gable':
      return <GableShapeDetails shapeDetails={shapeDetails} />;
    case 'Jack':
      return <JackShapeDetails shapeDetails={shapeDetails} />;
    case 'Scissors':
      return <ScissorsShapeDetails shapeDetails={shapeDetails} />;
    case 'Valley':
      return <ValleyShapeDetails shapeDetails={shapeDetails} />;
    case 'Piggyback':
      return <PiggybackShapeDetails shapeDetails={shapeDetails} />;
    default:
      assertExhaustiveSwitch(shapeDetails);
  }
}
